import ApiService from '@/services/ApiService.js'
import moment from 'moment'

export const namespaced = true
export const state = {
  patients: [],
  totalPatients: '',
  selectedPatient: '',
  selectedDate: moment()
}

export const mutations = {
  SET_PATIENTS(state, value) {
    state.patients = value
  },
  SET_PATIENTS_COUNT(state, value) {
    state.totalPatients = value
  },
  SET_SELECTED_PATIENT(state, value) {
    state.selectedPatient = value
  },
  SET_SELECTED_DATE(state, value) {
    state.selectedDate = value
  }
}

export const actions = {
  createPatient({ commit }, patient) {
    return ApiService.postPatients(patient).then(() => {
      commit('ADD_PATIENT', patient)
    })
  },
  fetchPatients({ commit }) {
    const user = JSON.parse(localStorage.getItem('user'))
    return ApiService.getPatients(user.id)
      .then(response => {
        let patients = response.data.map(item => {
          return {
            ...item,
            label: item.alias + ' (' + item.podMac.substr(-4) + ')'
          }
        })
        commit('SET_PATIENTS_COUNT', response.headers['x-total-count'])
        commit('SET_PATIENTS', patients)
        if (!this.state.selectedPatient && patients.length) {
          commit('SET_SELECTED_PATIENT', patients[0])
        }
      })
      .catch(() => {
        //console.log('IN Catch: ')
      })
  }
}

export const getters = {
  patientCount: state => {
    return state.patients.length
  }
}
